(()=>{
  function init(root){
    if(root.dataset.carouselReady)return;
    root.dataset.carouselReady='true';
    const slides=[...root.querySelectorAll('[data-home-slide]')];
    const copies=[...root.querySelectorAll('[data-home-copy]')];
    const artwork=root.querySelector('.hero-artwork');
    const giftUrl=artwork.getAttribute('href');
    const controls=root.querySelector('.home-carousel-controls');
    if(slides.length<2||!controls)return;
    controls.hidden=false;
    const buttons=[...root.querySelectorAll('[data-slide-to]')];
    const pause=root.querySelector('[data-carousel-pause]');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,paused=reduced.matches,timer,startX=null;
    function show(next){index=(next+slides.length)%slides.length;root.dataset.activeSlide=String(index);copies.forEach((c,i)=>{c.hidden=i!==index;c.classList.toggle("is-active",i===index);c.setAttribute("aria-hidden",String(i!==index));});artwork.setAttribute("href",index===1?root.dataset.storyUrl:giftUrl);artwork.setAttribute("aria-label",index===1?copies[1].querySelector("a").textContent.trim():copies[0].querySelector("a").textContent.trim());slides.forEach((s,i)=>{s.classList.toggle('is-active',i===index);s.setAttribute('aria-hidden',String(i!==index));});buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));}
    function stop(){clearInterval(timer);}
    function play(){stop();if(!paused&&!document.hidden)timer=setInterval(()=>show(index+1),6500);}
    buttons.forEach(b=>b.addEventListener('click',()=>{show(Number(b.dataset.slideTo));play();}));
    pause.setAttribute('aria-pressed',String(paused));
    pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));play();});
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',play);
    root.addEventListener('focusin',stop);root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget))play();});
    document.addEventListener('visibilitychange',play);
    root.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;stop();},{passive:true});
    root.addEventListener('touchend',e=>{if(startX!==null){const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)show(index+(dx<0?1:-1));startX=null;}play();},{passive:true});
    reduced.addEventListener('change',()=>{paused=reduced.matches;pause.setAttribute('aria-pressed',String(paused));play();});
    show(0);play();
  }
  const scan=()=>document.querySelectorAll('[data-home-carousel]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
